export default __webpack_public_path__ + "static/avenir-next-regular-94f2f163d4b698242fefbbacd2a09e04.otf";